import { render, staticRenderFns } from "./PublicDocumentSignature.vue?vue&type=template&id=e52c286c&scoped=true"
import script from "./PublicDocumentSignature.vue?vue&type=script&lang=js"
export * from "./PublicDocumentSignature.vue?vue&type=script&lang=js"
import style0 from "./PublicDocumentSignature.vue?vue&type=style&index=0&id=e52c286c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52c286c",
  null
  
)

export default component.exports